import { render, staticRenderFns } from "./wxApp.vue?vue&type=template&id=c72f5826&scoped=true"
import script from "./wxApp.vue?vue&type=script&lang=js"
export * from "./wxApp.vue?vue&type=script&lang=js"
import style0 from "./wxApp.vue?vue&type=style&index=0&id=c72f5826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72f5826",
  null
  
)

export default component.exports